import React from 'react';

interface IconProps {
  classes?: string;
  style?: React.CSSProperties;
}

export const TriangleDown: React.FC<IconProps> = ({ classes, style }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
      style={style}
    >
      <path d="M10 3.5L2 3.5L6 8.5L10 3.5Z" fill="currentColor" />
    </svg>
  );
};
